import mixpanel from 'mixpanel-browser'

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN
const MIXPANEL_DEBUG = process.env.NEXT_PUBLIC_MIXPANEL_DEBUG === 'true'

if (typeof window !== 'undefined') {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: MIXPANEL_DEBUG,
    track_pageview: true,
    persistence: 'localStorage'
  })
}

export const trackMixpanelEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties)
}

export const setMixpanelUser = (userId, userProperties = {}) => {
  mixpanel?.identify(userId||null)
  if (Object.keys(userProperties).length > 0) {
    mixpanel.people.set(userProperties)
  }
}

export const logoutMixpanelUser = () => {
  mixpanel.reset()
}

export default mixpanel
